export const formatThousandsCountToNDecimal = (
  number: number,
  decimalPlaces: number,
) => {
  if (Math.floor(number / 1000) === 0) return number;
  const tmp = number / 1000;
  const factorOfTen = Math.pow(10, decimalPlaces);

  return `${Math.round(tmp * factorOfTen) / factorOfTen}K`;
};
